import React from 'react';
import {
    Create,
    Datagrid,
    DeleteButton,
    FileField, FileInput,
    List,
    SimpleForm,
    useTranslate
} from 'react-admin';
import BackButton from '../components/BackButton';
import { API_URL } from '../variables/constant';


export const GuideConducteur2List = props => {
    console.log(``)
    const translate = useTranslate();
    return (
        <List {...props}
              filter={{ guideConducteur2: { "neq": null } }}
              sort={{ field: "updatedAt", order: "DESC" }}>
            <Datagrid>
                <FileView guide="guideConducteur2"/>
                <DeleteButton />
            </Datagrid>
        </List>
    )
};

const FileView = (props) => {
    return (
        <div>
        <a href={`${API_URL}/Containers/pdf/download/${props.record.guideConducteur2}`}>{props.record.guideConducteur2}</a>
        </div>
    )
}

const CustomForm = (props) => {
    const translate = useTranslate();
    return (
        <div className="w-100">
            <div className="d-flex flex-wrap">
                <div className="col-12">
                    <FileInput source="guideConducteur2" label="Related files" accept="application/pdf">
                        <FileField source="guideConducteur2" title="guideConducteur2" />
                    </FileInput>
                </div>
            </div>
        </div>
    )
};

export const GuideConducteur2Create = (props: any) => {
    const translate = useTranslate();
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mt-3">
                <BackButton/>
                <h3>{translate('guide.create')}</h3>
                <b></b>
            </div>
            <Create {...props}>
                <SimpleForm redirect="/GuideConducteur2">
                    <CustomForm/>
                </SimpleForm>
            </Create>
        </div>
    );
};

